module.exports = __webpack_public_path__ + "static/img/305.cb118e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200608/305.jpg
// module id = 9mxK
// module chunks = 0